import React from 'react';
import {useTranslation} from 'react-i18next';
import {
  Dialog,
  DialogContent,
  Button,
  DialogFooter,
  DialogHeader,
} from '@taopix/taopix-design-system';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../Context/UserInterface/UserInterfaceActionTypes';
import {useUserFlowState} from '../Context/UserFlow/UserFlowContext';
import {UserFlowType} from '../../Facade/UserFlow/UserFlowFacade';

export type SavePromptProps = {
  open: boolean;
};

const SavePrompt = ({open}: SavePromptProps) => {
  const {t} = useTranslation();
  const ui = useUiState();
  const userFlow = useUserFlowState();

  return (
    <Dialog
      open={open}
      width={!ui.state.isSmallScreen ? 400 : undefined}
      id="save-prompt"
      theme={'tpx-theme-dialogs'}
      title={t('signin:str_TitleBenefitSaveYourProject')}
      aria-live="assertive"
    >
      <DialogContent>
        <p>{t('*:str_MessageSaveProjectPrompt')}</p>
      </DialogContent>
      <DialogFooter isSmallScreen={ui.state.isSmallScreen}>
        <Button
          label={t('*:str_ButtonNotNow')}
          buttonStyle={'secondary'}
          onClick={() => {
            ui.dispatch(UserInterfaceActions.setSavePrompt(false));
          }}
        />
        <Button
          label={t('*:str_ButtonSave')}
          buttonStyle={'primary'}
          onClick={() => {
            // close prompt
            userFlow.activateUserFlow(UserFlowType.Save);
            ui.dispatch(UserInterfaceActions.setSavePrompt(false));
            // If the project name can be edited (not changed) show dialog
          }}
        />
      </DialogFooter>
    </Dialog>
  );
};

export default SavePrompt;
